export default __webpack_public_path__ + "static/lozenge-do-1-dark-f9457b05ef557ad1053908f3d2065f893da4560ce2cc86f26831fc3e2df2be16.png";